import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component, ElementRef,
  EventEmitter, HostBinding, HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output, ViewChild,
  ViewEncapsulation
} from "@angular/core";
import {KEYBOARD_KEY_PRESSED} from "../../providers/keyboardEvents.provider";
import {Observable} from "rxjs";
import {DEFAULT_MODAL_ANIMATION, DEFAULT_MODAL_CONTAINER_ANIMATION} from "../../animations/default-modal-amimation";
import {DestroyStreamService} from "../../services";
import {takeUntil} from "rxjs/operators";

@Component({
  selector: 'int-modal',
  templateUrl: 'int-modal.component.html',
  styleUrls: ['int-modal.component.scss'],
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    DestroyStreamService
  ],
  animations: [
    DEFAULT_MODAL_ANIMATION(),
    DEFAULT_MODAL_CONTAINER_ANIMATION({duration: 0.2, timingFunction: 'ease'}),

  ]
})
export class IntModalComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() width = '300px';
  @Input() mode: 'center' | 'right-side' | 'left-side' | 'top' | string = 'center';
  @Input() modalStyles = '';
  @Input() doNotCloseByTapOnOverlay = false;
  @Input() autoScroll = true;

  @Output() closeEvent = new EventEmitter<any>();

  init = false;

  @ViewChild('inner') private readonly inner!: ElementRef

  constructor(
    private readonly destroy$: DestroyStreamService,
    @Inject(KEYBOARD_KEY_PRESSED) readonly pressedKey$: Observable<string>
  ) {
    pressedKey$.pipe(takeUntil(this.destroy$)).subscribe(key => {
      if(['Escape'].indexOf(key) !== -1 && !this.doNotCloseByTapOnOverlay)
        this.closeEvent.emit();
    })
  }

  @HostBinding('@defaultModalContainerAnimation') get animation() {
    return true;
  }

  @HostBinding('class') get _hc() {
    return this.mode;
  }

  @HostBinding('style.overflow-y') get _owy() {
    return this.autoScroll ? 'auto' : 'inherit';
  }

  @HostListener('mousedown') hostClick() {
    this.closeModal();
  }

  preventAction(event: any): void {
    event.stopPropagation();
  }

  open() {
    // console.log('modal open');
  }

  closeModal() {
    if(!this.doNotCloseByTapOnOverlay) {
      this.closeEvent.emit();
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      //this.renderer.
      this.inner.nativeElement.click();

      //this.elementRef.nativeElement.focus();
      //this.vcr.element.nativeElement.focus();
    }, 0)
  }

  ngOnInit() {
    this.init = true;
  }

  ngOnDestroy() {
    //this.init = false;
  }
}
